import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Post-lancering',
  subtitle: 'Bekijk de Go Live-checklistdata en stel de screeningdatum na lancering in.',
  go_live_checklist: {
    labels: {
      yes: 'Ja',
      no: 'Nee',
    },
    title: 'Go Live-checklist',
    form: {
      is_google_business_available: {
        label: 'Google Business beschikbaar',
      },
      is_smart_pricing_configured: {
        label: 'Goedkopere prijzen dan Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Promotiefolder verstuurd',
      },
      is_menu_fully_configured: {
        label: 'Alle menu-items beschikbaar',
      },
      has_offers_on_competitor_platforms: {
        label: 'Heeft het restaurant aanbiedingen op Wolt, Uber, Lieferando (exclusief gratis bezorgaanbieding)?',
      },
      is_instagram_story_shared: {
        label: 'Instagram-story gedeeld met eigenaar',
      },
      is_order_system_connected_to_website: {
        label: 'Foodamigos-website verbonden OF eigen restaurantwebsite met online bestelknop toegevoegd',
      },
      google_business_connected_by: {
        label: 'Hoe hebben we toegang gekregen tot het Google Bedrijfsprofiel?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]:
            'Salesmanager heeft google@foodamigos.io uitgenodigd',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Salesmanager heeft het eerste verzoek zelf verzonden vanaf de telefoon van de eigenaar',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'Onboardingmanager heeft Google Bedrijfsprofiel aangevraagd (SM heeft niet uitgenodigd & geen toegang aangevraagd)',
          null: 'N.v.t.',
        },
      },
    },
    buttons: {
      save: 'Opslaan',
    },
    toasts: {
      success: 'Succesvol opgeslagen',
      error: 'Opslaan mislukt',
    },
  },
  post_launch_screening: {
    title: 'Post-lancering screening',
    form: {
      screening_date: {
        label: 'Screeningdatum',
      },
    },
    toasts: {
      success: 'Succesvol opgeslagen',
      error: 'Opslaan mislukt',
    },
    buttons: {
      save: 'Opslaan',
    },
  },
};
